<zui-separator
  [size]="size"
  [spacing]="innerWidth < 500 ? 'large': spacing"
  [position]="position"
  [orientation]="orientation">
</zui-separator>
